/* @flow */

import * as React from 'react';

import useReduxState from 'src/shared/app/base/hook/useReduxState';
import useRouteConfig from 'src/shared/app/base/route/hook/useRouteConfig';
import ScrollToTop from 'src/shared/app/base/route/component/ScrollToTop';
import {
  getRouteMain,
  getRouteScrollToTop,
} from 'src/shared/app/base/route/util/routeUtils';

import useRouteMatch from 'src/shared/app/base/route/hook/useRouteMatch';
import MainSwitchDumb from './MainSwitchDumb';

type Props = {
  layoutClass?: string,
};

const MainSwitch = ({ layoutClass }: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */
  const state = useReduxState();
  const config = useRouteConfig();

  const route = useRouteMatch();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  const children = React.createElement(getRouteMain(route, state, config));
  const element = getRouteScrollToTop(route) ? (
    <ScrollToTop>{children}</ScrollToTop>
  ) : (
    children
  );

  return <MainSwitchDumb layoutClass={layoutClass}>{element}</MainSwitchDumb>;
};

export default React.memo<Props>(MainSwitch);
